<template>
  <div
    v-if="isMissionControlSession"
    class="wg-admin-mode-toggle"
    role="group"
    aria-label="Admin mode"
  >
    <span class="wg-admin-mode-toggle__label">Admin</span>
    <v-switch
      class="wg-admin-mode-toggle__switch"
      :input-value="isWhiteGloveAdminMode"
      hide-details
      dense
      inset
      @change="onChange"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'WhiteGloveAdminModeToggle',
  computed: {
    ...mapState(['isWhiteGloveAdminMode']),
    isMissionControlSession () {
      return Boolean(this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount)
    },
  },
  methods: {
    onChange (value) {
      this.$store.commit('setWhiteGloveAdminMode', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.wg-admin-mode-toggle {
  --wg-admin-toggle-purple: #a232b5;
  --wg-admin-toggle-surface: #f7f4fc;
  --wg-admin-toggle-label: #373737;

  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 5px 6px 10px;
  border-radius: 10px;
  border: 1px solid var(--wg-admin-toggle-purple);
  background: var(--wg-admin-toggle-surface);
  flex-shrink: 0;
  box-sizing: border-box;
}

.wg-admin-mode-toggle__label {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  color: var(--wg-admin-toggle-label);
  font-family: inherit;
  user-select: none;
}

.wg-admin-mode-toggle__switch {
  margin-top: 0 !important;
  padding-top: 0 !important;
  flex-shrink: 0;
}

.wg-admin-mode-toggle__switch ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
  padding: 0 !important;

  .v-input--selection-controls__input { 
    margin-right: 0 !important;
  }
}

.wg-admin-mode-toggle__switch ::v-deep .v-input--switch {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.wg-admin-mode-toggle__switch ::v-deep .v-input--selection-controls {
  padding-top: 0 !important;
  margin-top: 0 !important;
}
</style>

<!-- Vuetify switch uses currentColor on track/thumb; scope overrides under root class only -->
<style lang="scss">
.wg-admin-mode-toggle .wg-admin-mode-toggle__switch.v-input--switch.v-input--is-dirty .v-input--switch__track {
  background-color: #a232b5 !important;
  color: #a232b5 !important;
  opacity: 1 !important;
}

.wg-admin-mode-toggle .wg-admin-mode-toggle__switch.v-input--switch:not(.v-input--is-dirty) .v-input--switch__track {
  background-color: rgba(162, 50, 181, 0.28) !important;
  color: rgba(162, 50, 181, 0.28) !important;
  opacity: 1 !important;
}

.wg-admin-mode-toggle .wg-admin-mode-toggle__switch.v-input--switch .v-input--switch__thumb {
  background-color: #ffffff !important;
  color: #ffffff !important;
}
</style>
